var map = {
	"./utilities/window-width.js": 159
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/frontend ^.*window\-width\.js$
// module id = 158
// module chunks = 0